// MentionText - renders chat/comment text with @handle chips (hover card + link
// to /@handle), $CASHTAG chips and safe http(s) links. Never uses
// dangerouslySetInnerHTML: every segment is a React text node or element.
import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { parseSegments } from './mentionParse';
import HandleHoverCard from './HandleHoverCard';
import { useSocialT } from './socialUi';

export function MentionChip({ handle, raw }) {
  const T = useSocialT();
  return (
    <HandleHoverCard handle={handle}>
      <Box component={Link} to={`/@${handle}`} data-mention={handle}
        sx={{ color: T.accent, bgcolor: T.chipBg, fontWeight: 600, textDecoration: 'none', px: '5px', mx: '-1px', borderRadius: '6px',
          transition: 'background-color 120ms', '&:hover': { bgcolor: T.chipHover }, '&:focus-visible': { outline: `2px solid ${T.accent}`, outlineOffset: 1 } }}>
        {raw || `@${handle}`}
      </Box>
    </HandleHoverCard>
  );
}

export default function MentionText({ text, component = 'span', sx, linkify = true, ...rest }) {
  const T = useSocialT();
  const segs = useMemo(() => parseSegments(text), [text]);
  return (
    <Box component={component} sx={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap', ...sx }} {...rest}>
      {segs.map((s, i) => {
        switch (s.type) {
          case 'mention': return <MentionChip key={i} handle={s.value} raw={s.raw} />;
          case 'group':
            return <Box component="span" key={i} sx={{ color: T.accent, bgcolor: T.chipBg, fontWeight: 600, px: '5px', mx: '-1px', borderRadius: '6px' }}>{s.raw}</Box>;
          case 'cashtag':
            return (
              <Box component={Link} key={i} to={`/app/stocks/${encodeURIComponent(s.value)}`} data-cashtag={s.value}
                sx={{ color: T.green, fontWeight: 600, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>{s.raw}</Box>
            );
          case 'url':
            return linkify ? (
              <Box component="a" key={i} href={s.value} target="_blank" rel="noopener noreferrer nofollow ugc"
                sx={{ color: T.accent, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>{s.value}</Box>
            ) : s.value;
          default: return <React.Fragment key={i}>{s.value}</React.Fragment>;
        }
      })}
    </Box>
  );
}
